import { Controller, useFormContext } from "react-hook-form";

function NumberSelectField({ name, label, required, disabled, disabledIncrement }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <fieldset className="number-field">
      <div className="number-field-row">
        <label>
          {label}
          {!required && <span className="label-optional"> (Optional)</span>}
        </label>
        <Controller
          name={name}
          control={control}
          defaultValue={1}
          // rules={rules}
          render={({ field }) => {
            // If disabled, always show 0 and prevent changes
            const value = disabled ? 0 : field.value;
            return (
              <div className="number-controls">
                <button
                  type="button"
                  className="number-btn minus"
                  onClick={() => field.onChange(Math.max(field.value - 1, 0))}
                  disabled={disabled}
                  aria-label="Decrease"
                >
                  -
                </button>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  readOnly
                  {...field}
                  value={value}
                  className="number-input"
                  disabled={disabled}
                />
                <button
                  type="button"
                  className="number-btn plus"
                  onClick={() => field.onChange(field.value + 1)}
                  disabled={disabled || disabledIncrement}
                  aria-label="Increase"
                >
                  +
                </button>
              </div>
            );
          }}
        />
        {/* <small>{subtext}</small> */}
        <span className="input-error">{errors?.[name]?.message}</span>
      </div>
    </fieldset>
  );
}

export default NumberSelectField;
